"use client";

import { CapabilityOverviewSection } from "@/components/sections/capability-overview";
import { capabilityOverview } from "@/lib/data/services-competitive-intelligence";

export function CapabilityOverview() {
  return (
    <CapabilityOverviewSection
      eyebrow={capabilityOverview.eyebrow}
      title={capabilityOverview.title}
      intro={capabilityOverview.intro}
      primaryAccent={capabilityOverview.primaryAccent}
      secondaryAccent={capabilityOverview.secondaryAccent}
      tertiaryAccent={capabilityOverview.tertiaryAccent}
      frameworks={capabilityOverview.frameworks}
      biasLevels={capabilityOverview.biasLevels}
      variantDimensions={capabilityOverview.variantDimensions}
      localization={capabilityOverview.localization}
    />
  );
}